import * as React from 'react';

export const Colors = {
    colorA: '#366697'

}
